import { Box, Grid, Typography, useTheme } from '@mui/material';
import { AccordionValue } from '../../../model/accordion-value';

function ClaimDetailSummary(props: any) {
  const theme = useTheme();

  return (
    <Box sx={{ m: theme.custom.styles.claimSummaryDetailItemStyle }}>
      {props?.info?.map(function (object: AccordionValue, i: number) {
        return (
          <Grid container key={object.rowName}>
            <Grid
              sx={(i + 1) % 2 === 0 ? theme.custom.styles.evenRow : theme.custom.styles.oddRow}
              key={object.rowName}
              item
              xs={6}
            >
              <Typography
                variant="body1"
                sx={{
                  marginLeft: '10px',
                  marginTop: '15px',
                  marginBottom: '15px',
                }}
                key={object.rowName + '-p'}
                id={'2'}
              >
                <b>{object.rowName}</b>
              </Typography>
            </Grid>
            <Grid
              sx={(i + 1) % 2 === 0 ? theme.custom.styles.evenRow : theme.custom.styles.oddRow}
              key={object.rowValue}
              item
              xs={6}
            >
              <Typography
                variant="body1"
                title={object.rowName + '-' + object.rowValue}
                key={object.rowValue + '-p'}
                sx={{ width: '100%', textAlign: 'end', marginRight: '1rem' }}
                data-dd-privacy={object.rowName === 'Claimant Name' ? 'mask' : undefined}
              >
                {object.rowValue}
              </Typography>
            </Grid>
            <Grid
              sx={
                (i + 1) % 2 !== 0
                  ? theme.custom.styles.hrWrapperOdd
                  : i + 1 !== props?.info?.length
                    ? theme.custom.styles.hrWrapperEven
                    : {}
              }
              item
              xs={12}
            >
              <hr style={theme.custom.styles.listItemDividerHrStyle}></hr>
            </Grid>
          </Grid>
        );
      })}
    </Box>
  );
}

export default ClaimDetailSummary;
